
export const getMarketingContent = {
  query: `query MarketingContent($product: String, $marketingType: String){
    getMarketingContent(product: $product, marketingType: $marketingType) {
        product
        marketingType
        web {
            headerImage
            marketingUrl
            buttonText
            infoCards {
                title
                body
                icon
            }
            additionalProps {
                ourServices {
                    headerText
                    bodyText
                }
            }
        },
    }
  }
`,
};
